// @flow
import React from 'react';
import { StyleSheet, View } from 'react-native';
import runAfterInteractions from '../../../utils/runAfterInteractions';
import I18n from '../../../lib/i18n';
import { RCTModal as Modal } from '../Modal';
import RequestStatusModalBody from './RequestStatusModalBody';

class PostRequestModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      visible: props.isLoading,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    // hackfix for when the modal is opened and then closed too quickly
    runAfterInteractions(() =>
      this.setState({
        visible: nextProps.isLoading,
      })
    );
  }

  onRequestClose = () => {};

  render() {
    return (
      <View>
        <Modal animationType="fade" transparent visible={this.state.visible} onRequestClose={this.onRequestClose}>
          <View style={styles.modalBackground}>
            <RequestStatusModalBody icon="cart" title={I18n.t('order')} text={I18n.t('orderReceived')} isLoading />
          </View>
        </Modal>
      </View>
    );
  }
}

type State = {
  visible: boolean,
};

type Props = {
  isLoading: boolean,
};

const styles = StyleSheet.create({
  modalBackground: {
    backgroundColor: 'rgba(0,0,0,0.5)',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
});

export default PostRequestModal;
